<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card v-if="player" light>
      <v-card-title class="headline grey--text">
        {{ player.id > 0 ? "Edición de jugador" : "Nuevo Jugador"}}
      </v-card-title>
      <v-card-text class="pt-0">
          <v-container fluid>
              <v-layout row wrap ref="form">
                  <v-flex xs12>
                    <v-text-field
                        slot="activator"
                        label="Nombre de Jugador"
                        v-model="data.name"
                        light
                        color="green"
                        ref="name"
                        :rules="rules.required"
                    ></v-text-field>

                  </v-flex>

              </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="cancelPlayerDialog()">Cancelar</v-btn>
        <v-btn color="green darken-1" flat @click.native="submit()">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Player from '@/models/player'

export default {
  name: "NewPlayerDialog",
  props: {
    dialog: { required: true, default: false },
    player: {required: false, default: null},
    teamid: {required: true, default: -1}
  },
  data: () => ({
    rules: {
        required: [
            val => {
                let res = ((String(val) || '').length > 0 && val != null) || 'Este campo es obligatorio'
                return res
            }
        ]
    },
    data:{
      name:""
    }
  }),
  computed:{
    form(){
      return {
        name: this.data.name
      }
    }
  },
  watch:{
    player(player){
      this.data.name = player.name
    }
  },
  methods: {
    ...mapActions([
      'saveNewPlayer',
      'cancelPlayerDialog',
      'updatePlayer'
    ]),
    submit() {
      var hasErrors = false

      Object.keys(this.form).forEach(f => {
          if(this.$refs[f])
              if(!this.form[f])
                  hasErrors = true

          if(this.$refs[f])
              this.$refs[f].validate(true)
      })

      if(hasErrors) return



      var player = new Player()
      player.name = this.data.name
      player.teamId = this.teamid
      player.id = this.player.id

      if(this.player.id > 0){
        this.updatePlayer(player)
        return
      }
      this.saveNewPlayer(player)

    }
  }
}
</script>
<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/teams/NewPlayerDialog.vue